module.exports = __webpack_public_path__ + "img/longchim.934641c0.jpg";